import { Theme } from "src/API"
import { paths } from "src/app/routing/paths"
import AuthForm from "src/components/AuthForm/AuthForm"
import Link from "src/components/Link"
import { useAnalyticsPage } from "src/hooks/useAnalytics"
import { useRedirectIfLoggedIn } from "src/hooks/useRedirectIfLoggedIn"
import { login } from "src/redux/auth/actions"
import { useDispatch } from "src/redux/hooks"
import { isUnauthorizedError } from "src/services/api/errors"
import { environment } from "src/services/environment"
import { translateText } from "src/services/translations/textTranslations"
import { validators } from "src/services/validate"
import styled from "styled-components"

const ForgotPassword = styled(Link).attrs(({ theme: { mode, oldColors } }) => ({
  tag: "p",
  size: 14,
  color: mode === Theme.LivaNova ? oldColors.text.suggestLink : oldColors.primary.pink,
  underline: false
}))`
  display: block;
  margin: 15px;
  margin-bottom: 0;
  text-align: left;
`

interface FormValues {
  email: string
  password: string
}
const initialValues: FormValues = {
  email: environment.loginDefaultEmail ?? "",
  password: environment.loginDefaultPassword ?? ""
}

const Login = () => {
  useAnalyticsPage("DP_Initiate_Sign_In")
  const dispatch = useDispatch()

  useRedirectIfLoggedIn()

  return (
    <AuthForm
      title="LIVANOVA/LOGIN/TITLE"
      submitLabel="LOGIN/SUBMIT_BUTTON"
      fields={[
        {
          fieldType: "text",
          name: "email",
          label: "FIELD/EMAIL/LABEL",
          hint: "FIELD/GENERIC/HINT/REQUIRED"
        },
        {
          fieldType: "password",
          name: "password",
          label: "FIELD/PASSWORD/LABEL",
          hint: "FIELD/PASSWORD/HINT",
          passedProps: { hasValidationIcon: false }
        }
      ]}
      initialValues={initialValues}
      onSubmit={async (values) => {
        const { error } = await dispatch(login(values))
        return error ? (isUnauthorizedError(error) ? "LOGIN/ERROR/UNAUTHORIZED" : "LOGIN/ERROR/FAILED") : null
      }}
      validationSchema={{
        email: validators.email,
        password: validators.password
      }}
    >
      <ForgotPassword
        data-cy="reset-password"
        to={paths.RESET_PASSWORD}
        children={translateText("LOGIN/FORGOT_PASSWORD")}
      />
    </AuthForm>
  )
}

export default Login
